// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveLowerEnum } from '@/constants/case-insensitive-enum';
import { z } from 'zod';

export const productFieldTypeSchema = caseInsensitiveLowerEnum([
  'text',
  'multiline_text',
  'number',
  'integer',
  'date',
  'time',
  'date_time',
  'boolean',
]);

export type ProductFieldType = z.infer<typeof productFieldTypeSchema>;

interface FieldInformation {
  fieldTypeLabel: string;
  fieldTypeDataTypeLabel: string;
  selectable: boolean;
}

export const PRODUCT_FIELD_TYPE_DATA: Record<
  ProductFieldType,
  FieldInformation
> = {
  text: {
    fieldTypeLabel: 'Text',
    fieldTypeDataTypeLabel: 'String',
    selectable: true,
  },
  multiline_text: {
    fieldTypeLabel: 'Multiline text',
    fieldTypeDataTypeLabel: 'String',
    selectable: true,
  },
  number: {
    fieldTypeLabel: 'Decimal',
    fieldTypeDataTypeLabel: 'decimal',
    selectable: true,
  },
  integer: {
    fieldTypeLabel: 'Integer',
    fieldTypeDataTypeLabel: 'integer',
    selectable: true,
  },
  date: {
    fieldTypeLabel: 'Date',
    fieldTypeDataTypeLabel: 'Date',
    selectable: false,
  },
  date_time: {
    fieldTypeLabel: 'Date and time',
    fieldTypeDataTypeLabel: 'Date and time',
    selectable: false,
  },
  time: {
    fieldTypeLabel: 'Time',
    fieldTypeDataTypeLabel: 'time',
    selectable: false,
  },
  boolean: {
    fieldTypeLabel: 'Boolean',
    fieldTypeDataTypeLabel: 'Boolean',
    selectable: false,
  },
};
